export function OvaCommunityIllustration() {
  return null;
}
